module.exports = __webpack_public_path__ + "static/media/thumbnail-hostels.e7f9eeb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-hostels.png
// module id = 397
// module chunks = 0